import { render, staticRenderFns } from "./index-upload.vue?vue&type=template&id=13dba2e4"
import script from "./index-upload.vue?vue&type=script&lang=js"
export * from "./index-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports